import React, { useEffect, useState } from "react";
import { RouteComponentProps } from "react-router-dom";
import TemperatureApi from "../../api/TemperatureApi";
import IconClearViolation from "../../Icons/TopCommandPanel/ClearViolation";
import IconTempTarget from "../../Icons/TopCommandPanel/TempTarget";
import { useTypedSelector } from "../../redux/reducers/RootReducer";
import {
  getTemperatureSensorsCollection,
  getTemperatureSensorsFetchStatus,
} from "../../redux/reducers/TemperatureReducer";
import Modal from "../Common/Modal";
import TextBox from "../Common/TextBox";
import Header from "../Header/Header";
import HeaderButton from "../Header/HeaderButton";
import LayoutContent from "../LayoutContent";
import { getModule } from "./../../redux/reducers/ModuleReducer";
import Breadcrumb from "./../Header/Breadcrumb";
import TemperatureGraph from "./TemperatureGraph";
import TemperatureNavSubMenu from "./TemperatureNavSubMenu";

type TempParams = {
  moduleIdentifier: string;
};
export default function Temperature({ match }: RouteComponentProps<TempParams>) {
  const temperatureSensorCollection = useTypedSelector((state) => getTemperatureSensorsCollection(state));

  const moduleIdentifier = match.params.moduleIdentifier
    ? match.params.moduleIdentifier
    : temperatureSensorCollection.allIds[0];

  const module = useTypedSelector((state) => getModule(state, moduleIdentifier));

  const moduleTemperatureFetchStatus = useTypedSelector((state) => getTemperatureSensorsFetchStatus(state));

  const [targetTemp, setTargetTemp] = useState(0);
  const [showTargetPopUp, setShowTargetPopUp] = useState(false);

  useEffect(() => {
    TemperatureApi.getTargetTemperature(moduleIdentifier).then((targetTemp) => {
      setTargetTemp(targetTemp);
    });
  }, []);

  const updateTargetTemp = () => {
    TemperatureApi.setTargetTemperature(moduleIdentifier, targetTemp);
    setShowTargetPopUp(false);
  };

  if (!moduleTemperatureFetchStatus.completed) {
    return <div>Loading temperatures...</div>;
  }

  const moduleTemperatureSensor = temperatureSensorCollection.byId[moduleIdentifier];

  if (!moduleTemperatureSensor) {
    return <div>{"Module " + moduleIdentifier + " doesn't support temperature control"} </div>;
  }

  return (
    <LayoutContent>
      <LayoutContent.Header>
        <Header>
          <Breadcrumb
            items={[{ title: `Temperature - ${module.name}`, to: `/temperature/${module.name}`, disabled: false }]}
          />
          <Header.RightSide>
            <HeaderButton
              id={"TEMP_TARGET"}
              label="Temperature Target"
              icon={<IconTempTarget />}
              onClick={() => setShowTargetPopUp(true)}
            />
            <HeaderButton
              id={"CLEAR_VIOLATION"}
              label="Clear Violation"
              icon={<IconClearViolation />}
              onClick={() => {
                TemperatureApi.clearTemperatureViolation(moduleIdentifier);
              }}
            />
          </Header.RightSide>
        </Header>
      </LayoutContent.Header>
      <LayoutContent.Content
        style={{
          padding: 0,
        }}
      >
        <TemperatureGraph
          style={{
            width: "100%",
            height: "100%",
          }}
          moduleIdentifier={moduleIdentifier}
          temperatureSensorCollection={moduleTemperatureSensor.temperatureSensorCollection}
        />
        <Modal
          style={{ width: 350 }}
          show={showTargetPopUp}
          onHide={() => {
            setShowTargetPopUp(false);
            TemperatureApi.getTargetTemperature(moduleIdentifier).then((targetTemp) => {
              setTargetTemp(targetTemp);
            });
          }}
        >
          <Modal.Header title="Set Temperature Target" />
          <Modal.Body>
            <div className="target-popup-body">
              <label>{"Temperature (\u2103)"}</label>
              <TextBox
                variant="number"
                name="temp-popup"
                value={targetTemp}
                onChange={(temp) => setTargetTemp(temp as number)}
              />
            </div>
          </Modal.Body>
          <Modal.Footer
            styleOkButton={{ width: 85 }}
            styleCancelButton={{ width: 85 }}
            onClickOk={updateTargetTemp}
            onClickCancel={() => {}}
          />
        </Modal>
      </LayoutContent.Content>
      {temperatureSensorCollection.allIds.length > 1 && (
        <LayoutContent.SubMenu>
          <TemperatureNavSubMenu />
        </LayoutContent.SubMenu>
      )}
    </LayoutContent>
  );
}
